import image1 from "../images/image-product-1.jpg";
import image2 from "../images/image-product-2.jpg";
import image3 from "../images/image-product-3.jpg";
import image4 from "../images/image-product-4.jpg";
import thumb1 from "../images/image-product-1-thumbnail.jpg";
import thumb2 from "../images/image-product-2-thumbnail.jpg";
import thumb3 from "../images/image-product-3-thumbnail.jpg";
import thumb4 from "../images/image-product-4-thumbnail.jpg";

export const Images = [
	{
		id: 1,
		image: image1,
		alt: "shoe 1",
	},
	{
		id: 2,
		image: image2,
		alt: "shoe 2",
	},
	{
		id: 3,
		image: image3,
		alt: "shoe 3",
	},
	{
		id: 4,
		image: image4,
		alt: "shoe 4",
	},
];

export const Thumbs = [
	{
		id: 1,
		image: thumb1,
		alt: "thumbnail",
	},
	{
		id: 2,
		image: thumb2,
		alt: "thumbnail",
	},
	{
		id: 3,
		image: thumb3,
		alt: "thumbnail",
	},
	{
		id: 4,
		image: thumb4,
		alt: "thumbnail",
	},
];
